var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.327,
    height: 20.327,
    viewBox: "0 0 21.327 21.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-library-books",
    "data-name": "Icon material-library-books",
    d: "M5.133,7.265H3V22.195a2.139,2.139,0,0,0,2.133,2.133H20.062V22.195H5.133ZM22.195,3H9.4A2.139,2.139,0,0,0,7.265,5.133v12.8A2.139,2.139,0,0,0,9.4,20.062h12.8a2.139,2.139,0,0,0,2.133-2.133V5.133A2.139,2.139,0,0,0,22.195,3Zm-1.066,9.6H10.465V10.465H21.128Zm-4.265,4.265h-6.4V14.73h6.4Zm4.265-8.531H10.465V6.2H21.128Z",
    transform: "translate(-3 -3)",
    fill: "#30346B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.6ddfdf183195417b43121dfb4f91812b.svg";
export { ForwardRef as ReactComponent };